import { render } from "./InvestmentScenario.vue?vue&type=template&id=377ef963&scoped=true"
import script from "./InvestmentScenario.vue?vue&type=script&lang=js"
export * from "./InvestmentScenario.vue?vue&type=script&lang=js"

import "./InvestmentScenario.vue?vue&type=style&index=0&id=377ef963&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377ef963"]])

export default __exports__